
export const SET_SORT_COLUMN = 'SET_SORT_COLUMN';

export const setSortColumn = (typeSort) => {
	return {
		type: SET_SORT_COLUMN,
		payload: typeSort,
	};
};
